import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { RuleInterface } from '@vendasta/automata';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
} from '@angular/forms';
import { positiveIntegerWithMaxValidatorBuilder } from '../../../common/utils/number-validator';
import { periodDays, periodHours, rateLimitingTypeAnyEntity } from '../../rate-filter';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'automata-create-snapshot-report-panel',
  templateUrl: './create-snapshot-report-panel.component.html',
  styleUrls: ['./create-snapshot-report-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class CreateSnapshotReportPanelComponent extends CommonActionPanelComponent implements OnInit {
  periodDays: string = periodDays;
  periodHours: string = periodHours;
  createSnapshotForm: FormGroup;

  ngOnInit(): void {
    super.ngOnInit();
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    this.createSnapshotForm = new FormGroup({
      infer_business_data: new FormControl(jsonData.infer_business_data || false),
      frequency: new FormControl(jsonData.frequency || 10, positiveIntegerWithMaxValidatorBuilder(500)),
      length: new FormControl(jsonData.length || 5, positiveIntegerWithMaxValidatorBuilder(100)),
      period: new FormControl(jsonData.period || this.periodDays, this.periodValidator),
    });
    this.savingEnabled = true;
  }

  // This section defines the rules that govern control flow coming out of the step.
  // You should almost never have to implement this method beyond returning an empty list.
  // If you believe your action should results in control flow changes, contact us first.
  getRules(): RuleInterface[] {
    return [];
  }

  // Return data from the form.
  // This corresponds to the input parameters on the Task Definition.
  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    jsonData.infer_business_data = this.createSnapshotForm.controls.infer_business_data.value;
    jsonData.rate_limiting_type = rateLimitingTypeAnyEntity;
    jsonData.frequency = this.createSnapshotForm.controls.frequency.value;
    jsonData.length = this.createSnapshotForm.controls.length.value;
    jsonData.period = this.createSnapshotForm.controls.period.value;
    return jsonData;
  }

  // Return true when your form is valid.
  // This allows the automation to be saved when true.
  isFormValid(): boolean {
    return this.createSnapshotForm.valid;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.createSnapshotForm];
  }

  periodValidator(control: AbstractControl): ValidationErrors | null {
    if (control.value !== periodDays && control.value !== periodHours) {
      return { invalid: true };
    }
    return null;
  }
}
